import { createRoot } from 'react-dom/client';
import { initNewRelic } from 'monitoring/initNewRelic';
import { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';

import { getSubdomain } from 'utility/helpers/get-subdomain';
import { LayoutContextProvider } from 'utility/context/Layout';
import { PUBLIC_URL } from 'utility/env';
import Spinner from 'components/@vuexy/spinner/Fallback-spinner';
import { store } from 'redux/storeConfig/store';

import ApiClientWrapper from './ApiClientWrapper';

import './index.scss';

// Synchronous fetch — config.json is a tiny local file served from the same origin.
// Blocking here ensures NR captures everything from first paint.
const configRequest = new XMLHttpRequest();
configRequest.open('GET', `${PUBLIC_URL}/config.json`, false);
configRequest.send();
if (configRequest.status === 200) {
  const config = JSON.parse(configRequest.responseText);
  initNewRelic(config.apiUrl, config.envTarget, getSubdomain());
}

const LazyApp = lazy(() => import('./App'));

const container = document.getElementById('root') || document.createElement('div');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <div
      id="print-print"
      style={{
        position: 'absolute',
        padding: '1em',
        background: '#fff',
        color: '#000',
        top: 0,
        left: 0,
        minHeight: '100vh',
        width: '100vw',
        zIndex: 99999,
      }}
    />
    <ApiClientWrapper>
      <Suspense fallback={<Spinner />}>
        <LayoutContextProvider>
          <LazyApp />
        </LayoutContextProvider>
      </Suspense>
    </ApiClientWrapper>
  </Provider>,
);
